export * from './events';
export { trackEvent, trackPageView, initRudderStack, updateRudderStackConsent } from './methods';
